function getIanaTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export default getIanaTimeZone;
